<style lang="scss">
.zoezi-bottom-bar-button {
    padding: 0 4px !important;
    .v-btn__content {
        div {
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        display: block;
        width: calc(100% - 8px);
    }
}
</style>

<template>
    <v-btn class="zoezi-button-thin" :color="color" text height="inherit" @click="buttonClicked">
        <v-icon>{{icon}}</v-icon>
        <div>{{translateTitle ? $translate(title) : title}}</div>
    </v-btn>
</template>

<script>
export default {
    name: 'zoezi-bottom-bar-button',

    zoezi: {
        title: 'Bottom row button',
        icon: 'mdi-gesture-tap-button'
    },

    props: {
        title: {
            title: 'Title',
            type: String,
            default: 'Knapp'
        },
        icon: {
            title: 'Icon',
            type: String,
            fulltype: 'icon',
            default: 'mdi-information-outline'
        },
        link: {
            title: 'Link',
            type: String,
            fulltype: 'page',
            default: '/'
        },
        color: {
            title: 'Text color',
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        openMobileMenu: {
            title: 'Open mobile menu on click',
            type: Boolean,
            default: false
        },
        translateTitle: {
            title: 'Translate title',
            type: Boolean,
            default: true
        }
    },

    methods: {
        buttonClicked() {
            if (this.openMobileMenu) {
                this.$store.commit('setShowMobileMenu', !this.$store.state.showMobileMenu);
            } else if (this.openQrScanner) {
                this.$store.commit('showCheckinDialog', { checkinResources: this.checkinResources, onlyShowQrScanner: true });
            } else if (!this.$root.edit && this.link) {
                this.$root.followLink(this.link);
            } else {
                this.$emit('click');
            }
        }
    }
}
</script>
